import { ActionIcon } from './actionIcon'
import { ActionIcons, ActionIconColors } from './enums'
import {
  faCube,
  faLock,
  faLockOpen,
  faSpinner,
  faExclamationTriangle,
  faRandom,
  faKey,
  faAddressCard,
  faTrash,
  faCheck,
  faEye
} from '@fortawesome/free-solid-svg-icons'
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NewReleasesIcon from '@material-ui/icons/NewReleases'

export const MAX_DATATABLE_RESULTS = 1000

export const NO_DATA = '--'

export const DEFAULT_BALANCE_ZONE = 'ESP'
export const DEFAULT_COMPANY_ID = 1

export const DEFAULT_DECIMAL_POSITIONS = 2
export const AVAILABLE_ACTION_ICONS: ActionIcon[] = [
  {
    id: ActionIcons.BUNDLE,
    icon: faCube,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.LOCK_DISABLED,
    icon: faLock,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.LOCK_TEMPORARY,
    icon: faKey,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.LOCK,
    icon: faLock,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.UNLOCK,
    icon: faLockOpen,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.LOADING,
    icon: faSpinner,
    color: ActionIconColors.DISABLED
  },
  {
    id: ActionIcons.WARNING,
    icon: faExclamationTriangle,
    color: ActionIconColors.WARNING
  },
  {
    id: ActionIcons.ERROR,
    icon: faExclamationTriangle,
    color: ActionIconColors.ERROR
  },
  {
    id: ActionIcons.FLANGES,
    icon: faRandom,
    color: ActionIconColors.PRIMARY
  },
  {
    id: ActionIcons.PRINCIPAL,
    icon: faAddressCard,
    color: ActionIconColors.PRIMARY
  },
  {
    id: ActionIcons.NEW_ITEM,
    icon: {
      iconName: 'new-releases',
      prefix: 'fas',
      icon: [
        20,
        20,
        [],
        'f2bb',
        'm23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z'
      ]
    },
    color: ActionIconColors.PRIMARY
  },
  {
    id: ActionIcons.DELETE_ITEM,
    icon: faTrash,
    color: ActionIconColors.PRIMARY
  },
  {
    id: ActionIcons.SELECTED_ITEM,
    icon: faCheck,
    color: ActionIconColors.PRIMARY
  },
  {
    id: ActionIcons.FOCUSED_ITEM,
    icon: faEye,
    color: ActionIconColors.PRIMARY
  }
]
